<template>
  <v-container>
    <!-- <v-card> -->
    <!-- seleccion de estados y colores-->
    <v-container>
      <h2>Estados</h2>
    </v-container>
    <!-- ------------------------------------------------------------------------ -->
    <!-- Filtro fechas -->
    <div>
      <v-container>
        <h2>Filtro asociado</h2>
        <v-row>
          <!-- {{ this.pages[selectedPage] }} -->
          <!-- {{ this.pages[selectedPage].item_list }} -->
          <v-select
            :items="filtrosRelacionados"
            item-text="name"
            label="Select an Item"
            v-model="selectedItem.filtroAsociado"
            return-object
          ></v-select>
          <!-- </v-col> -->
        </v-row>
        <v-row>
          <v-btn
            block
            @click="addEmptyState"
          >
            Nuevo Estado
          </v-btn>
        </v-row>
      </v-container>
      <v-container>
        <!-- Selección de estados y colores -->
        <v-container>
          <h2>Estados</h2>
          <v-row
            v-for="(estado, index) in selectedItem.customized.estados"
            :key="index"
            class="style-estados"
            :md="4"
            :sm="6"
          >
            <v-col cols="1">
              <input
                type="checkbox"
                v-model="estado.checked"
              />
            </v-col>
            <v-col cols="6">
              <input
                type="text"
                v-model="estado.nombre"
                class="style-estados-label"
              />
            </v-col>
            <v-col cols="2">
              <input
                type="number"
                v-model="estado.valor"
                class="style-estados-value"
              />
            </v-col>
            <v-col cols="2">
              <input
                type="color"
                v-model="estado.color"
                @change="cambiar(estado, $event.target.value)"
                class="style-estados-color"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </div>
    <!-- ------------------------------------------------------------- -->
    <!-- Seleector del formato del eje X -->
    <div>
      <v-container>
        <h2>Formato eje X</h2>
        <v-select
          v-model="selectedItem.customized.tipoEjeX"
          :items="options"
          item-text="texto"
          item-value="id"
          label="Selecciona una opción"
        ></v-select>
      </v-container>
    </div>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import { mapState } from "vuex";
// import moment from 'moment';
export default {
  data() {
    return {
      dateFormatted: null,
      // selectedItem: { id: 1, texto: "Hora" },
      options: [
        { id: 1, texto: "Hora" },
        { id: 2, texto: "Fecha completa" },
      ],
    };
  },
  computed: {
    ...mapState(["selectedItem", "pages", "selectedPage"]),

    filtrosRelacionados() {
      return this.pages[this.selectedPage].item_list.filter((el) => {
        return el.settings.component_name === "filtro-entre-fechas";
      });
    },
  },

  mounted() {
    console.group("DATOS DEL ELEMENTO SELECCIONADO");
    console.log(this.selectedItem);
    console.groupEnd();
  },

  methods: {
    //methodos
    addEmptyState() {
      this.selectedItem.customized.estados.push({
        nombre: "??",
        color: "#FFFFFF",
        valor: this.selectedItem.customized.estados.length + 1,
      });
    },
  },
};
</script>

<style scoped>
.color-square {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.style-estado {
  display: flex;
  align-items: center; /* Centra verticalmente los elementos */
}
/* Asegúrate de que el drawer ocupe todo el alto de la ventana */
.v-navigation-drawer {
  height: 100vh; /* Altura completa del viewport */
  top: 64px; /* Desplazamiento desde la parte superior */
  max-height: calc(100% - 64px); /* Ajusta la altura máxima teniendo en cuenta el desplazamiento */
  width: 300px; /* Ancho del drawer */
  overflow-y: auto; /* Permite el desplazamiento vertical si el contenido es más grande que el contenedor */
}

/* Contenedor principal del drawer */
.v-navigation-drawer__content {
  padding: 16px; /* Espaciado interno */
}

/* Estilos para los encabezados */
h2 {
  margin: 0 0 16px 0; /* Margen inferior para separación */
}

/* Estilo de los botones */
.v-btn {
  margin-bottom: 16px; /* Espacio inferior para separación entre botones y otros elementos */
}

/* Estilo para los inputs */
.v-input__control {
  margin-bottom: 16px; /* Espacio inferior para separación entre campos de entrada */
}

/* Flexbox para el contenedor de estados */
.style-estados-container {
  display: flex;
  align-items: center; /* Alinear verticalmente en el centro */
  gap: 10px; /* Espacio entre elementos */
  flex-wrap: nowrap; /* Evita el ajuste de línea para mantener todos los elementos en una línea */
}

/* Estilos específicos para cada tipo de input */
.style-estados-checkbox {
  flex-shrink: 0; /* Evita que el checkbox se reduzca */
}

.style-estados-label {
  flex: 1; /* Permite que el input de texto use el espacio restante */
  max-width: 80px; /* Limita el ancho máximo del input de texto */
}

.style-estados-value {
  width: 50px; /* Asigna un ancho fijo al input numérico */
  flex-shrink: 0; /* Evita que el input numérico se reduzca */
}

.style-estados-color {
  width: 30px; /* Asigna un ancho fijo al input de color */
  height: 30px; /* Asigna una altura fija al input de color */
  border: none; /* Elimina cualquier borde */
  padding: 0; /* Elimina padding */
  cursor: pointer; /* Cambia el cursor a mano */
  margin-top: -6px; /* Centra el input de color horizontalmente dentro de su columna */
}
</style>
